import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { change } from 'redux-form';
import { FaEdit } from 'react-icons/fa';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import styles from '../../assets/css/TogglerButton.module.css';
import { notifySet } from '../../Services/Actions/CommonActions';
import { UseStyles } from '../../components/TableStyles/tableSX';
import {
  addEmailContent,
  emailContentSearch,
  notificationList,
  notificationUpdate,
  updateEmailContent,
} from '../../Services/Utils/EmailNotificationApis';
import SwipeableContentDrawer from './SwippableDrawerRight';

export function EmailActions(props) {
  const {
    startUpData, setCurrentNotification, setViewNotification, setContentDrawerOpen
  } = props;
  const [isNotificationActive, setIsNotificationActive] = useState(startUpData.email);
  const dispatch = useDispatch();

  const handleEditEmailContent = (content) => {
    setViewNotification(content);
    const params = { start: 0, recordSize: '' };
    const data = { notificationView: { id: content.id } };
    emailContentSearch(data, params).then((res) => {
      setCurrentNotification(res.list[0]);
      dispatch(change('emailContentForm', 'subject', res.list[0]?.subject ));
      dispatch(change('emailContentForm', 'emailBcc', res.list[0]?.emailBcc ));
      dispatch(change('emailContentForm', 'emailCc', res.list[0]?.emailCc ));
      dispatch(change('emailContentForm', 'emailContent', res.list[0]?.content ));
      let option = {};
      option = {
        id: res.list[0]?.emailAccountView?.id,
        label: res.list[0]?.emailAccountView?.name,
        value: res.list[0]?.emailAccountView?.name,
        text: res.list[0]?.emailAccountView?.name,
      };
      dispatch(change('emailContentForm', 'emailAccountView', option ));
      setContentDrawerOpen(true);
    });
  };

  return (
    <>
      <EmailToggler
        startUpData={startUpData}
        setIsNotificationActive={setIsNotificationActive}
        isNotificationActive={isNotificationActive}
      />
      {isNotificationActive ? <FaEdit style={{ marginLeft: '20px', fontSize: '25px' }} onClick={() => { handleEditEmailContent(startUpData); }} /> : ''}
    </>
  );
}

// Email Content disable enable toggler
export function EmailToggler(props) {
  const { startUpData, isNotificationActive, setIsNotificationActive } = props;
  const dispatch = useDispatch();

  const handlleEmailActiveChange = (e, res) => {
    const data = {
      id: res.id,
      email: !isNotificationActive
    };
    notificationUpdate(data).then((resp) => {
      const { hasError, message } = resp;
      if (hasError === false) {
        dispatch(notifySet({ type: 'success', message }));
        setIsNotificationActive(!isNotificationActive);
      } else if (hasError === true) {
        dispatch(notifySet({ type: 'error', message }));
      }
    });
  };

  return (
    <label className={styles.switch}>
      <input
        type="checkbox"
        id="Btn"
        className={`${styles['switch-input']}`}
        checked={isNotificationActive}
        onChange={(e) => handlleEmailActiveChange(e, startUpData)}
      />
      <span className={`${styles.slider} ${styles['slider-round']}`} />
    </label>
  );
}

function EmailContentList() {
  const dispatch = useDispatch();
  const classes = UseStyles();

  // table pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setrowsPerPage] = useState(10);
  const [itemOffset, setItemOffset] = useState(0);
  const [listRecordSize, setListRecordSize] = useState(0);
  const onPageChange = (event, newPage) => {
    setPage(newPage);
    const newOffset = (newPage * rowsPerPage) % listRecordSize;
    setItemOffset(newOffset);
  };
  const handleChangeRowsPerPage = (event) => {
    setrowsPerPage(event.target.value);
  };

  // notification list view
  const [notifications, setNotifications] = useState([]);
  const [currentNotification, setCurrentNotification] = useState();
  const [viewNotification, setViewNotification] = useState();

  function notificationView() {
    const data = {};
    const params = {
      start: itemOffset,
      recordSize: rowsPerPage,
    };

    notificationList(data, params).then((res) => {
      setNotifications(res.list);
      setListRecordSize(res.records);
    });
  }
  useEffect(() => {
    notificationView();
  }, [itemOffset, rowsPerPage]);

  // slide toggler
  const [contentDrawerOpen, setContentDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setContentDrawerOpen(!contentDrawerOpen);
  };

  // content edit submit
  const onSubmitFunction = (formData) => {
    const data = {
      id: currentNotification?.id,
      emailBcc: formData.emailBcc,
      emailCc: formData.emailCc,
      content: formData.emailContent,
      subject: formData.subject,
      emailAccountView: {
        id: formData.emailAccountView?.id,
        name: formData.emailAccountView?.text
      },
      notificationView: {
        id: currentNotification?.notificationView?.key
      }
    };
    if (currentNotification) {
      updateEmailContent(data).then((resp) => {
        const { hasError, message } = resp;
        if (hasError === false) {
          setContentDrawerOpen(false);
          dispatch(notifySet({ type: 'success', message }));
        } else if (hasError === true) {
          dispatch(notifySet({ type: 'error', message }));
        }
      });
    } else {
      data.notificationView = { id: viewNotification?.id };
      addEmailContent(data).then((respo) => {
        const { hasError, message } = respo;
        if (hasError === false) {
          setContentDrawerOpen(false);
          dispatch(notifySet({ type: 'success', message }));
        } else if (hasError === true) {
          dispatch(notifySet({ type: 'error', message }));
        }
      });
    }
  };

  return (
    <div>
      <div className="title-con">
        <div className="row align-items-center">
          <div className="col-sm-12 col-md-12 col-lg-5">
            <div className="title-left-con">
              <h6>Notifications</h6>
            </div>
          </div>
        </div>
      </div>
      <div>
        <Paper sx={{ overflow: 'hidden', marginTop: '30px' }}>
          <TableContainer
            component={Paper}
            className="tableContainer"
            sx={{ maxHeight: 720, marginRight: 'auto' }}
          >
            <Table
              stickyHeader
              className={classes.root}
            >
              <TableHead>
                <TableRow>
                  <TableCell width={70}>No.</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell width={150}>Email</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {notifications?.map((startUpData, key) => (
                  <TableRow
                    key={key}
                    hover
                    tabIndex={-1}
                    className="muiTableRow"
                  >
                    <TableCell>{key + 1 + itemOffset}</TableCell>
                    <TableCell>{startUpData?.name}</TableCell>
                    <TableCell>
                      <EmailActions
                        startUpData={startUpData}
                        setCurrentNotification={setCurrentNotification}
                        setViewNotification={setViewNotification}
                        setContentDrawerOpen={setContentDrawerOpen}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 20]}
            component="div"
            count={listRecordSize}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={onPageChange}
            onRowsPerPageChange={handleChangeRowsPerPage}
            className="tablepaginationcon"
          />
        </Paper>
      </div>
      <SwipeableContentDrawer
        toggleDrawer={toggleDrawer}
        contentDrawerOpen={contentDrawerOpen}
        onSubmitFunction={onSubmitFunction}
        notificationName={currentNotification ? currentNotification?.notificationView?.value : 'Add Notification'}
      />
    </div>
  );
}

export default EmailContentList;
